export default __webpack_public_path__ + "static/media/info_start.min.fbf7e1fc.png";